import { Tab, Tooltip, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import React from 'react';

const useStyles = makeStyles((theme: any) => ({
  tabroot: {
    minWidth: theme.spacing(12),
    maxWidth: theme.spacing(30),
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
    textTransform: 'none',
  },
  tabSelected: {
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
  tabUnselected: {
    fontWeight: 500,
    color: theme.palette.tab.offselected,
  },
  disabledTab: { opacity: 0.5 },
  enabledTab: { opacity: 1 },
  tooltip: {
    fontSize: "1rem",
    whiteSpace: "pre-line",
    textAlign: "center"
  }
}));

type CustomTabtype = {
  text: string,
  value: string,
  currentValue: string,
  disabled?: boolean,
  tooltipTitle?: string
}

export const CustomTab = ({
  text,
  value,
  currentValue,
  disabled,
  tooltipTitle = "",
  ...props
}: CustomTabtype) => {
  const classes = useStyles();
  return (
    <Tooltip
      title={tooltipTitle}
      arrow
      placement="top"
      classes={{ tooltip: classes.tooltip }}
    >
      <div>
        <Tab
          {...props}
          value={value}
          classes={{ root: classes.tabroot }}
          disabled={disabled}
          label={(
            <Typography
              className={clsx({
                [classes.tabSelected]: currentValue === value,
                [classes.tabUnselected]: currentValue !== value,
                [classes.enabledTab]: !disabled,
                [classes.disabledTab]: disabled
              })}
              variant="body2"
            >
              {text}
            </Typography>
          )}
        />
      </div>
    </Tooltip>

  );
};

CustomTab.defaultProps = { disabled: false, };
export default CustomTab;
